// ### SOCKET MANAGEMENT
export const LOAD_VIZ_SOCKET = 'modelVizSaga/LOAD_VIZ_SOCKET'

// ### SOCKET MANAGEMENT
export const loadVisualizationSocket = ({ tid, teamId, aid }) => {
	return { type: LOAD_VIZ_SOCKET, tid, teamId, aid }
}
